/**
 * Five Elephant — custom theme scripts.
 * Header: hide on scroll down, show on scroll up (sticky chrome).
 */
(function () {
  'use strict';

  function initHeaderScrollBehavior() {
    if (!document.querySelector('[data-header-sticky]')) return;

    var CHROME_HIDDEN_CLASS = 'header-chrome-hidden';
    var BODY_HIDDEN_CLASS = 'header-scroll-hidden';
    var SCROLL_DELTA = 4;
    var lastY = window.scrollY || 0;
    var hidden = false;
    var ticking = false;

    function getHeaderChrome() {
      return document.querySelector('[data-header-sticky]');
    }

    function getTopThreshold() {
      var header = document.querySelector('.page-header');
      return header ? Math.max(header.offsetTop, 0) : 0;
    }

    function isDropdownOpen() {
      return !!document.querySelector(
        '.page-header .header__dropdown.is-visible, .page-header .grandparent.is-visible, [data-header-wrapper].meganav--visible'
      );
    }

    function isScrollLocked() {
      return document.documentElement.hasAttribute('data-scroll-locked');
    }

    function closeOpenMenus() {
      document.querySelectorAll('[data-hover-disclosure-toggle].is-visible').forEach(function (trigger) {
        var key = trigger.getAttribute('data-hover-disclosure-toggle');
        var disclosure = key ? document.getElementById(key) : null;
        trigger.classList.remove('is-visible');
        trigger.setAttribute('aria-expanded', 'false');
        if (disclosure) disclosure.classList.remove('is-visible');
      });

      var wrapper = document.querySelector('[data-header-wrapper]');
      if (wrapper) {
        wrapper.classList.remove('meganav--visible', 'meganav--is-transitioning');
      }
    }

    function ensureThemeSticky(position) {
      var chrome = getHeaderChrome();
      if (!chrome || position <= getTopThreshold()) return;
      chrome.classList.add('js__header__stuck');
    }

    function setHidden(nextHidden) {
      var chrome = getHeaderChrome();
      if (hidden === nextHidden) return;
      hidden = nextHidden;
      if (chrome) chrome.classList.toggle(CHROME_HIDDEN_CLASS, nextHidden);
      document.body.classList.toggle(BODY_HIDDEN_CLASS, nextHidden);
      document.body.classList.remove('product-header-hidden');
      if (nextHidden) closeOpenMenus();
    }

    function evaluate(position, goingDown, goingUp) {
      if (isScrollLocked() || isDropdownOpen()) {
        setHidden(false);
        return;
      }

      if (position <= getTopThreshold()) {
        setHidden(false);
        return;
      }

      if (goingDown) {
        ensureThemeSticky(position);
        setHidden(true);
      } else if (goingUp) {
        ensureThemeSticky(position);
        setHidden(false);
      }
    }

    function updateFromScrollEvent(e) {
      var detail = e && e.detail ? e.detail : {};
      var position = typeof detail.position === 'number' ? detail.position : window.scrollY;
      evaluate(position, !!detail.down, !!detail.up);
      lastY = position;
    }

    function onNativeScroll() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function () {
        ticking = false;
        var y = window.scrollY || 0;
        var delta = y - lastY;

        if (Math.abs(delta) < SCROLL_DELTA) return;

        evaluate(y, delta > 0, delta < 0);
        lastY = y;
      });
    }

    function forceShow() {
      setHidden(false);
    }

    document.addEventListener('theme:scroll', updateFromScrollEvent);
    window.addEventListener('scroll', onNativeScroll, { passive: true });
    window.addEventListener('theme:scroll:lock', forceShow);
    document.addEventListener('theme:scroll:lock', forceShow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderScrollBehavior);
  } else {
    initHeaderScrollBehavior();
  }
})();
// Fe card size pills — price update (BSS B2B compatible)
document.addEventListener('change', function (e) {
  var input = e.target;
  if (!input || input.type !== 'radio' || !input.dataset.variantPrice) return;

  var card = input.closest('.fe-product-card');
  if (!card) return;

  var priceEl = card.querySelector('[data-fe-card-price]');
  if (!priceEl) return;

  var variantId = input.dataset.variantId;
  var cents = parseInt(input.dataset.variantPrice, 10);
  if (isNaN(cents)) return;

  var formatted = (cents / 100).toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });

  // Update BSS B2B variant attribute so it recalculates for the right variant
  if (variantId) {
    priceEl.setAttribute('bss-b2b-variant-id', variantId);
  }

  priceEl.textContent = formatted;
});
